import { ConfigMurucaAdvancedSearchLayout } from '@net7/boilerplate-muruca';

const config:ConfigMurucaAdvancedSearchLayout = {
  title: 'Ricerca avanzata',
  resultsUrl: { it: '/results', en: 'en/results', es: 'es/results' },
  hasDynamicOptions: true,
  formConfig: {
    submitButton: {
      label: 'advancedsearch#submit',
    },
    resetButton: {
      label: 'advancedsearch#reset',
    },
    groups: [
      {
        id: 'group-1',
        sections: ['section-1'],
        classes: 'form-group-1',
        options: {
          label: 'advancedsearch#section_global',
          isOpen: true,
          showHeader: false,
        },
      },
      {
        id: 'group-2',
        sections: ['section-2'],
        classes: 'form-group-1',
        options: {
          label: 'advancedsearch#section_work',
          isOpen: true,
          showHeader: true,
        }
      },
      {
        id: 'group-3',
        sections: ['section-3'],
        classes: 'form-group-1',
        options: {
          label: 'advancedsearch#section_edition',
          isOpen: true,
          showHeader: true,
        }
      },
      {
        id: 'group-4',
        sections: ['section-4'],
        classes: 'form-group-1',
        options: {
          label: 'advancedsearch#section_sample',
          isOpen: true,
          showHeader: true,
        }
      },
    ],
    sections: [
      {
        id: 'section-1',
        title: '',
        inputs: [
          {
            id: 'query-fulltext',
            type: 'text',
            data: {
              id: 'query-fulltext',
              label: 'advancedsearch#fulltext_text',
              placeholder: '',
              //icon: 'n7-icon-search',
              inputPayload: 'search-input',
              enterPayload: 'search-enter',
              iconPayload: 'search-icon',
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
          {
            id: 'resource-type',
            type: 'checkbox',
            info: 'advancedsearch#section_info',
            state: {
              value: [
                'opere',
                'edizioni',
                'esemplari'
              ],
            },
            data: {
              id: 'resource-type',
              checkboxes: [
                {
                  label: 'advancedsearch#label_works',
                  payload: 'opere',
                  id: 'opere'
                },
                {
                  label: 'advancedsearch#label_editions',
                  payload: 'edizioni',
                  id: 'edizioni',
                },
                {
                  label: 'advancedsearch#label_samples',
                  payload: 'esemplari',
                  id: 'esemplari',
                }
              ],
            },
          }
        ]
      },
      {
        id: 'section-2',
        title: '',
        inputs: [
          {
            id: 'bibl_opera_autore',
            type: 'select',
            data: {
              id: 'bibl_opera_autore',
              label: 'advancedsearch#label_author',
              options: []

            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
          {
            id: 'bibl_opera_traduttore',
            type: 'select',
            data: {
              id: 'bibl_opera_traduttore',
              label: 'advancedsearch#label_translator',
              options: []

            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
          {
            id: 'work_language',
            type: 'checkbox',
            data: {
              id: 'work_language',
              legend: 'advancedsearch#language',
              checkboxes: [
                {
                  id: 'italiano',
                  payload: 'italiano',
                  label: 'advancedsearch#language_ita'
                },
                {
                  id: 'spagnolo',
                  payload: 'spagnolo',
                  label: 'advancedsearch#language_esp'
                }
              ]

            },
            state: {
              value: [],
              disabled: false,
              hidden: false,
            },
          },
          {
            id: 'work_cycle',
            type: 'select',
            data: {
              id: 'work_cycle',
              label: 'advancedsearch#label_cycle',
              options: [
                {
                  value: '',
                  label: '---'
                },
                {
                  label: 'Amadís',
                  value: 'Amadís'
                },
                {
                  label: 'Belianís de Grecia',
                  value: 'Belianís de Grecia'
                },
                {
                  label: 'Clarián',
                  value: 'Clarián'
                },
                {
                  label: 'Demanda del santo Grial',
                  value: 'Demanda del santo Grial'
                },
                {
                  label: 'Espejo de caballerías',
                  value: 'Espejo de caballerías'
                },
                {
                  label: 'Espejo de príncipes y caballeros',
                  value: 'Espejo de príncipes y caballeros'
                },
                {
                  label: 'Florambel',
                  value: 'Florambel'
                },
                {
                  label: 'Florando de Inglaterra',
                  value: 'Florando de Inglaterra'
                },
                {
                  label: 'Floriseo',
                  value: 'Floriseo'
                },
                {
                  label: 'Félix Magno',
                  value: 'Félix Magno'
                },
                {
                  label: 'Lepolemo',
                  value: 'Lepolemo'
                },
                {
                  label: 'Morgante',
                  value: 'Morgante'
                },
                {
                  label: 'Palmerín de Inglaterra',
                  value: 'Palmerín de Inglaterra'
                },
                {
                  label: 'Palmerín',
                  value: 'Palmerín'
                },
                {
                  label: 'Quijote',
                  value: 'Quijote'
                },
                {
                  label: 'Renaldos',
                  value: 'Renaldos'
                },
                {
                  label: 'Tristán',
                  value: 'Tristán'
                }
              ]

            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
          {
            id: 'work_subject',
            type: 'select',
            data: {
              id: 'work_subject',
              label: 'advancedsearch#label_subject',
              options: [
                {
                  value: '',
                  label: '---'
                },
                {
                  label: 'poema cavalleresco',
                  value: 'poema cavalleresco'
                },
                {
                  label: 'romanzo cavalleresco',
                  value: 'romanzo cavalleresco'
                },
                {
                  label: 'riscrittura cavalleresca moderna',
                  value: 'riscrittura cavalleresca moderna'
                },
                {
                  label: "libretto d'opera",
                  value: "libretto d'opera"
                },
                {
                  label: 'poema cavalleresco',
                  value: 'poema cavalleresco'
                },
                {
                  label: 'romanzo',
                  value: 'romanzo'
                },
                {
                  label: 'altro',
                  value: 'altro'
                }
              ]

            },
            state: {
              value: [],
              disabled: false,
              hidden: false,
            },
          },
        ],
      },
      {
        id: 'section-3',
        title: '',
        inputs: [
          {
            id: 'query-place',
            type: 'text',
            data: {
              id: 'query-place',
              label: 'advancedsearch#label_place',
              placeholder: '',
              //icon: 'n7-icon-search',
              inputPayload: 'search-input',
              enterPayload: 'search-enter',
              iconPayload: 'search-icon',
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
          {
            id: 'query-editor',
            type: 'text',
            data: {
              id: 'query-editor',
              label: 'advancedsearch#label_editor',
              placeholder: '',
              //icon: 'n7-icon-search',
              inputPayload: 'search-input',
              enterPayload: 'search-enter',
              iconPayload: 'search-icon',
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
          {
            id: 'query-year',
            type: 'text',
            data: {
              id: 'query-year',
              label: 'advancedsearch#label_year',
              placeholder: '',
              //icon: 'n7-icon-search',
              inputPayload: 'search-input',
              enterPayload: 'search-enter',
              iconPayload: 'search-icon',
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
          {
            id: 'query-dedica',
            type: 'text',
            data: {
              id: 'query-dedica',
              label: 'advancedsearch#label_dedica',
              placeholder: '',
              //icon: 'n7-icon-search',
              inputPayload: 'search-input',
              enterPayload: 'search-enter',
              iconPayload: 'search-icon',
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
          {
            id: 'query-editorial-mark',
            type: 'text',
            data: {
              id: 'query-editorial-mark',
              label: 'advancedsearch#label_editorial-mark',
              placeholder: '',
              //icon: 'n7-icon-search',
              inputPayload: 'search-input',
              enterPayload: 'search-enter',
              iconPayload: 'search-icon',
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
          {
            id: 'query-id_pmdb',
            type: 'text',
            data: {
              id: 'query-id_pmdb',
              label: 'advancedsearch#label_id_pmdb',
              placeholder: '',
              //icon: 'n7-icon-search',
              inputPayload: 'search-input',
              enterPayload: 'search-enter',
              iconPayload: 'search-icon',
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          }
        ],
      },
      {
        id: 'section-4',
        title: '',
        inputs: [
          {
            id: 'marginalia',
            type: 'select',
            data: {
              id: 'marginalia',
              label: 'advancedsearch#marginalia_label',
              payload: '',
              options: [
                {
                  value: '',
                  label: '---',
                  disabled: false
                },
                {
                  value: 'true',
                  label: 'advancedsearch#value_exists',
                  disabled: false
                }, {
                  value: 'false',
                  label: 'advancedsearch#value_not_exists',
                  disabled: false
                }]
            }
          },
          {
            id: 'reproduction',
            type: 'select',
            data: {
              id: 'reproduction',
              label: 'advancedsearch#reproduction_label',
              payload: '',
              options: [
                {
                  value: '',
                  label: '---',
                  disabled: false
                },
                {
                  value: 'true',
                  label: 'advancedsearch#value_exists',
                  disabled: false
                }, {
                  value: 'false',
                  label: 'advancedsearch#value_not_exists',
                  disabled: false
                }]
            }
          },
          {
            id: 'digital_edition',
            type: 'select',
            data: {
              id: 'digital_edition',
              label: 'advancedsearch#digital_edition_label',
              payload: '',
              options: [
                {
                  value: '',
                  label: '---',
                  disabled: false
                },
                {
                  value: 'true',
                  label: 'advancedsearch#value_exists',
                  disabled: false
                }, {
                  value: 'false',
                  label: 'advancedsearch#value_not_exists',
                  disabled: false
                }]
            }
          },

          {
            id: 'query-library_city',
            type: 'text',
            data: {
              id: 'query-library_city',
              label: 'advancedsearch#label_library_city',
              placeholder: '',
              //icon: 'n7-icon-search',
              inputPayload: 'search-input',
              enterPayload: 'search-enter',
              iconPayload: 'search-icon',
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
          {
            id: 'query-library',
            type: 'text',
            data: {
              id: 'query-library',
              label: 'advancedsearch#label_library',
              placeholder: '',
              //icon: 'n7-icon-search',
              inputPayload: 'search-input',
              enterPayload: 'search-enter',
              iconPayload: 'search-icon',
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
          {
            id: 'query-previous_owner',
            type: 'text',
            data: {
              id: 'query-previous_owner',
              label: 'advancedsearch#label_previous_owner',
              placeholder: '',
              //icon: 'n7-icon-search',
              inputPayload: 'search-input',
              enterPayload: 'search-enter',
              iconPayload: 'search-icon',
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
          {
            id: 'query-note',
            type: 'text',
            data: {
              id: 'query-note',
              label: 'advancedsearch#label_note',
              placeholder: '',
              //icon: 'n7-icon-search',
              inputPayload: 'search-input',
              enterPayload: 'search-enter',
              iconPayload: 'search-icon',
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          }
        ],
      },
    ],
  },
};

export default config;
